import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import Images from "@/assets/images";
import FlightCard from "./FlightCard";
import { FontFamilies, Typography } from "@/constants/Typography";
import Icons from "@/assets/icons";

export default function WelcomeSlide2() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>File class actions -{"\n"}for free.</Text>
      {/* Card */}
      <FlightCard
        amount="Up to $15"
        title={"CLIF Bars False Advertising\nClass Action"}
        logo={
          <Image
            source={Images.classActionChocolate}
            style={styles.logoClifbar}
          />
        }
        status={[
          {
            icon: <Icons.NoProof />,
            text: "No proof required",
          },
          {
            icon: <Icons.Clock />,
            text: "5 days left",
          },
        ]}
      />
      {/* User review */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv1} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @Happyeverafter: &quot;Awesome site. It&apos;s a way to see if you
            qualify for money you didn&apos;t know about.&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 32,
  },
  logoClifbar: {
    width: 120,
    height: 120,
    borderTopRightRadius: 16,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#E7E7E733",
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  reviewContent: {
    flex: 1,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    fontFamily: FontFamilies.InterTight.Regular,
    fontSize: 13,
  },
});
